import React, { useState } from "react";
import css from "./portfolio.module.css";
import { SiCountingworkspro } from "react-icons/si";
import Heading from "../../reusable/Heading";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import Work from "./Work";
import { categories, myWorks } from "../../../data/portfolio";
import useScrollReveal from "../../../hooks/useScrollReveal";

const Portfolio = () => {
  const [parent] = useAutoAnimate();
  const [menuWorks, setMenuWorks] = useState(myWorks);
  const [selected, setSelected] = useState(categories[0]);
  const headingRef = useScrollReveal();

  const filter = (type) => {
    setMenuWorks(myWorks.filter((work) => work.category === type));
  };

  const getCount = (category) => {
    if (category === categories[0]) return myWorks.length;
    return myWorks.filter((w) => w.category === category).length;
  };

  const isAllView = selected === categories[0];

  return (
    <div style={{ paddingBottom: "7%" }} className="container px-lg-5">
      <div ref={headingRef} className="reveal">
        <Heading icon={<SiCountingworkspro />} headingTitle="Proof of Work" />
      </div>

      <p className={css.sectionIntro}>
        Selected products that show how I approach full-stack delivery,
        cross-platform mobile development, and AI integration in working
        applications.
      </p>

      <div className={css.works}>
        <div className={css.filterWrap} ref={parent}>
          {categories.map((category, i) => {
            const isActive = selected === category;
            const count = getCount(category);
            return (
              <button
                key={i}
                className={`${css.filterPill} ${isActive ? css.filterPillActive : ""}`}
                onClick={() => {
                  if (category === categories[0]) {
                    setMenuWorks(myWorks);
                  } else {
                    filter(category);
                  }
                  setSelected(category);
                }}
              >
                <span>{category}</span>
                <span className={css.filterCount}>{count}</span>
              </button>
            );
          })}
        </div>

        <div className={css.list} ref={parent}>
          {menuWorks.map((work, i) => (
            <div
              key={work.slug}
              className={`${css.work} ${isAllView && i === 0 ? css.workFeatured : ""}`}
            >
              <Work data={work} index={i} featured={isAllView && i === 0} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
